// @flow

import React, { useEffect } from 'react';
import type { Node } from 'react';
import { Location } from '@reach/router';
import styled, { createGlobalStyle } from 'styled-components';

import LoadFonts from 'fonts/load-fonts/Website';
import { Metadata } from 'components/Gui';
import type { PageMetaData } from 'components/Gui/Metadata';
import type { PageConfig, FooterLegal, HeaderConfig, FooterConfig } from 'contexts/page-context';
import { useSetPageState } from 'contexts/page-context';
import { maxWidthContainer, Width, Color } from 'styles';
import { paramsToObj } from 'utils';
import { IS_BROWSER } from 'Constants';
import type { AllImages } from 'hooks/use-images';

export const NAV_HIDING_QUERY_KEY = 'hidenav';

export const NAV_HIDING_QUERY_MAP = {
  '1': true,
};

const Wrapper = styled.div`
  ${maxWidthContainer(Width.XL)};
`;

const GlobalStyle = createGlobalStyle`
  html {
    background: ${Color.BLACK};
  }
  body {
    background: ${({ bodyBackground }) => bodyBackground};
  }
`;

const WebsiteDefaultPage = ({
  metaData,
  page,
  images,
  headerConfig = {},
  footerLegal = {},
  footerConfig = {},
  bodyBackground = Color.BLACK,
  children,
  ...rest
}: {
  images?: AllImages,
  metaData: PageMetaData,
  page: PageConfig,
  headerConfig?: HeaderConfig,
  footerLegal?: FooterLegal,
  footerConfig?: FooterConfig,
  bodyBackground?: string,
  children: Node,
}) => {
  const setPageState = useSetPageState();
  const { [NAV_HIDING_QUERY_KEY]: navHiddenValue } = IS_BROWSER ? paramsToObj(window.document.location.search) : {};
  const navHidden = navHiddenValue ? NAV_HIDING_QUERY_MAP[navHiddenValue] || false : false;
  useEffect(() => {
    setPageState({
      images,
      page,
      headerConfig: navHidden
        ? {
            toggleHidden: {
              nav: true,
              ctaButton: true,
            },
          }
        : headerConfig,
      footerLegal,
      footerConfig,
    });
  }, [setPageState, page, headerConfig, footerConfig, footerLegal, navHidden, images]);
  return (
    <>
      <Location>{props => <Metadata data={metaData} {...props} />}</Location>
      <LoadFonts />
      <GlobalStyle bodyBackground={bodyBackground} />
      <Wrapper {...rest}>{children}</Wrapper>
    </>
  );
};

export default WebsiteDefaultPage;
